import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from "swiper/modules";
import 'swiper/css';
import ref1 from '../../assets/images/liberyus-barsan.svg'
import ref2 from '../../assets/images/liberyus-mapa.svg'
import ref3 from '../../assets/images/liberyus-bursa.svg'
import ref4 from '../../assets/images/liberyus-burulas.svg'
import ref5 from '../../assets/images/liberyus-ustagrup.svg'
import ref6 from '../../assets/images/liberyus-alagoz.svg'
import ref7 from '../../assets/images/liberyus-ulastirma.svg'

const References = () => {
    return (
        <div className='references'>
            <Swiper
                spaceBetween={100}
                loop
                slidesPerView={6}
                autoplay={{ delay: 2500, disableOnInteraction: false, }}
                modules={[Autoplay]}
                breakpoints={{
                    300: { slidesPerView: 2 },
                    768: { slidesPerView: 4 },
                    1024: { slidesPerView: 6 }
                }}
            >
                <SwiperSlide><div className='item'><img src={ref1} alt='' /></div></SwiperSlide>
                <SwiperSlide><div className='item'><img src={ref2} alt='' /></div></SwiperSlide>
                <SwiperSlide><div className='item'><img src={ref3} alt='' /></div></SwiperSlide>
                <SwiperSlide><div className='item'><img src={ref4} alt='' /></div></SwiperSlide>
                <SwiperSlide><div className='item'><img src={ref5} alt='' /></div></SwiperSlide>
                <SwiperSlide><div className='item'><img src={ref6} alt='' /></div></SwiperSlide>
                <SwiperSlide><div className='item'><img src={ref7} alt='' /></div></SwiperSlide>
            </Swiper>
        </div>
    )
}

export default References
